import React, {useRef, useState} from 'react';
import {copyText} from "../../global/utils";
import Copy from "../../SVG/Copy";
import useClickOutside from "../../hooks/useClickOutside";
import {useTranslation} from '../../hooks/useTranslation';

const ToggleDropdown = ({index, lengthOfData, itemId, setSelectedItem, selectedItem, showNdxId=true, children}) => {
    const {t} = useTranslation();
    const dropdownRef = useRef(null);
    const [lastElem, setLastElem] = useState(false);
    const [isOpenDropDown, setIsOpenDropDown] = useState(false);

    useClickOutside(dropdownRef, () => {
        setIsOpenDropDown(false);
    });

    const handleDropdownToggle = (id) => {
        if (selectedItem === id) {
            setIsOpenDropDown(!isOpenDropDown);
        } else {
            setSelectedItem(id);
            setIsOpenDropDown(true);
        }
    };

    return (
        <div className='facility__td' ref={dropdownRef}>
            <img
                src='/assets/icons/dots.svg'
                alt='dots'
                className='dots'
                onClick={() => {
                    handleDropdownToggle(itemId);
                    if (lengthOfData === index + 1) {
                        setLastElem(true);
                    } else {
                        setLastElem(false);
                    }
                }}
            />
            {isOpenDropDown && selectedItem === itemId &&
                <div className={`facility__table-settings ${lastElem && 'facility__table-settings_last'}`}>
                    { showNdxId &&
                        <div
                            className={`blue `}
                            onClick={() => copyText(t('actions.copiedNDXID'), itemId)}>
                            <Copy color={'#999999'}/>
                            {t('toggleDropdown.ndxId')} {itemId}
                        </div>
                    }
                    {children}
                </div>
            }
        </div>
    )
}

export default ToggleDropdown;